import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-issue-filed',
  templateUrl: './issue-filed.component.html',
  styleUrls: ['./issue-filed.component.scss']
})
export class IssueFiledComponent implements OnInit {
  reference = '';

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.reference = params['ref'] || 'CISS-0000-00000';
    });
  }
}
